import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

// Fetch the seller GSTINs the current user may file for (access-gated dropdown).
export const getGstrGstins = createAsyncThunk(
  "gstrReport/getGstins",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(API_URL.GSTR_REPORT.GSTINS);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Fetch one GSTR-1 section's paged rows. payload: { section, gstin, fromDate, toDate, pageNumber, pageSize }
export const getGstr1Section = createAsyncThunk(
  "gstrReport/getGstr1Section",
  async (payload, { rejectWithValue }) => {
    try {
      const { section, gstin, fromDate, toDate, pageNumber, pageSize } = payload;
      const body = {
        gstin,
        fromDate,
        toDate,
        paging: {
          pageNumber: pageNumber || 1,
          pageSize: pageSize || 50,
        },
      };
      const { data } = await axios.post(
        API_URL.GSTR_REPORT.GSTR1_SECTION(section),
        body,
      );
      return { section, result: data?.data };
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const emptySection = { columns: [], rows: [], totalRecords: 0 };

const initialState = {
  gstins: [],
  sections: {}, // keyed by section key -> { columns, rows, totalRecords }
};

const gstrReportSlice = createSlice({
  name: "gstrReport",
  initialState,
  reducers: {
    resetGstrSections: (state) => {
      state.sections = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGstrGstins.fulfilled, (state, action) => {
        state.gstins = action.payload?.data || [];
      })
      .addCase(getGstr1Section.fulfilled, (state, action) => {
        const { section, result } = action.payload;
        state.sections[section] = result || { ...emptySection };
      });
  },
});

export const { resetGstrSections } = gstrReportSlice.actions;
export default gstrReportSlice.reducer;
